module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'not-mobile': !_vm.isMobile
    },
    attrs: {
      "id": "allocateWater"
    }
  }, [(_vm.isMobile) ? [_c('transition', {
    attrs: {
      "name": "sider-fade"
    }
  }, [_c('Mpage-side', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isOpen),
      expression: "isOpen"
    }],
    staticClass: "index-sider"
  })], 1)] : [_c('page-head'), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "sider-fade"
    }
  }, [_c('page-side', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isOpen),
      expression: "isOpen"
    }],
    staticClass: "index-sider",
    staticStyle: {
      "position": "fixed"
    }
  })], 1)], _vm._v(" "), _c('div', {
    staticClass: "index-content",
    class: {
      'index-content-open': !_vm.isOpen,
    },
    attrs: {
      "id": "main-router"
    }
  }, [_c('router-view')], 1), _vm._v(" "), _c('page-footer', {
    staticClass: "index-content",
    class: {
      'index-content-open': !_vm.isOpen
    },
    attrs: {
      "id": "main-footer"
    }
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-30e42811"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/allocateWater/index.vue
// module id = 906
// module chunks = 1